// src/views/ProductsPage.js

import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@mui/styles";
import {
  Grid,
  Typography,
  Divider,
  Autocomplete,
  TextField,
  MenuItem,
  Alert,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BuildIcon from "@mui/icons-material/Build";
import LockIcon from "@mui/icons-material/Lock";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import GavelIcon from "@mui/icons-material/Gavel";
import StethoscopeIcon from "@mui/icons-material/MedicalServices";
import PsychologyIcon from "@mui/icons-material/Psychology";
import HomeIcon from "@mui/icons-material/Home";
import PetsIcon from "@mui/icons-material/Pets";
import HotelIcon from "@mui/icons-material/Hotel";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import HandymanIcon from "@mui/icons-material/Handyman";
import ChairIcon from "@mui/icons-material/Chair";
import FlightIcon from "@mui/icons-material/Flight";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import PaidIcon from "@mui/icons-material/Paid";
import CarRepairIcon from "@mui/icons-material/CarRepair";
import WalletIcon from "@mui/icons-material/AccountBalanceWallet";
import axios from "axios";

import Header from "../components/Navbars/HeaderAyasa";
import footer from "assets/img/footerAyasa.png";
import FrequentQuestionsAyasa from "views/dialog/FrequentQuestionsAyasa";
import AyasaPaymentDialog from "views/dialog/AyasaPaymentDialog";

const NAVY = "#0B2D5C";
const ORANGE = "#FF7A1A";

const useStyles = makeStyles({
  page: {
    background: "#F4F6F9",
    minHeight: "100vh",
    paddingBottom: 60,
  },
  cardsWrap: {
    maxWidth: 1000,
    margin: "0 auto",
    padding: "0 20px",
  },
  card: {
    background: "#fff",
    borderRadius: 16,
    overflow: "hidden",
    boxShadow: "0 6px 24px rgba(11,45,92,0.10)",
    border: "2px solid transparent",
    cursor: "pointer",
    transition: "border-color .15s ease, transform .15s ease",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardSelected: {
    borderColor: ORANGE,
    transform: "translateY(-2px)",
  },
  cardHeader: {
    background: NAVY,
    color: "#fff",
    padding: "16px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  cardHeaderTitle: {
    fontWeight: 700,
    fontSize: "1.05rem",
    margin: 0,
  },
  cardPrice: {
    fontWeight: 800,
    fontSize: "1.6rem",
    color: ORANGE,
  },
  serviceRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "9px 18px",
    borderBottom: "1px solid #EFF2F6",
    fontSize: "0.85rem",
    color: "#22324A",
  },
  serviceIcon: {
    color: NAVY,
    fontSize: "1.1rem",
    flexShrink: 0,
  },
  serviceCount: {
    marginLeft: "auto",
    fontWeight: 700,
    color: NAVY,
    fontSize: "0.82rem",
    whiteSpace: "nowrap",
  },
  cardFooter: {
    marginTop: "auto",
    padding: "14px 18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "#F8FAFC",
  },
  selectLabel: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontWeight: 700,
    fontSize: "0.85rem",
  },
  advisorWrap: {
    maxWidth: 1000,
    margin: "36px auto 0",
    padding: "0 20px",
  },
  advisorBox: {
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 6px 24px rgba(11,45,92,0.10)",
    padding: "24px 28px",
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: "1rem",
    color: NAVY,
  },
  ctaWrap: {
    maxWidth: 1000,
    margin: "36px auto 0",
    padding: "0 20px",
    textAlign: "center",
  },
  payButton: {
    border: "none",
    borderRadius: 30,
    padding: "14px 48px",
    fontSize: "1rem",
    fontWeight: 700,
    cursor: "pointer",
    transition: "opacity .15s ease, transform .15s ease",
  },
  payButtonActive: {
    background: ORANGE,
    color: "#fff",
  },
  payButtonDisabled: {
    background: "#D7DCE3",
    color: "#8C96A3",
    cursor: "not-allowed",
  },
  helperText: {
    fontSize: "0.85rem",
    color: "#6B7585",
  },
});

const PLAN_PLUS = {
  id: "plus",
  name: "Plan Plus",
  price: 240,
  services: [
    { icon: <LocalShippingIcon />, label: "Grúa por accidente", count: "3" },
    { icon: <BuildIcon />, label: "Cambio de llanta", count: "3" },
    { icon: <LockIcon />, label: "Apertura de puertas", count: "3" },
    {
      icon: <HealthAndSafetyIcon />,
      label: "Ambulancia por accidente",
      count: "Ilimitado",
    },
    {
      icon: <GavelIcon />,
      label: "Asistencia legal telefónica",
      count: "Ilimitado",
    },
    {
      icon: <StethoscopeIcon />,
      label: "Telemedicina general",
      count: "Ilimitado",
    },
    {
      icon: <PsychologyIcon />,
      label: "Telemedicina psicología",
      count: "Ilimitado",
    },
    {
      icon: <PsychologyIcon />,
      label: "Telemedicina nutricionista",
      count: "Ilimitado",
    },
    { icon: <HomeIcon />, label: "Médico a domicilio", count: "Ilimitado" },
    {
      icon: <PetsIcon />,
      label: "Orientación veterinaria telefónica",
      count: "Ilimitado",
    },
    { icon: <HotelIcon />, label: "Hotel para mascotas", count: "4" },
    {
      icon: <LocalHospitalIcon />,
      label: "Hospitalización por accidente $200",
      count: "1",
    },
    {
      icon: <HandymanIcon />,
      label: "Cerrajería, electricidad y plomería",
      count: "3",
    },
    {
      icon: <ChairIcon />,
      label: "Limpieza de muebles (8 puestos)",
      count: "2",
    },
    {
      icon: <FlightIcon />,
      label: "Traslado aeropuerto Quito/Gye/Cuenca",
      count: "1",
    },
    {
      icon: <DirectionsCarIcon />,
      label: "Vehículo sustituto (10 días)",
      count: "1",
    },
    { icon: <PaidIcon />, label: "Raspones y abolladuras $200", count: "1" },
    {
      icon: <CarRepairIcon />,
      label: "Reparación parabrisas/retrovisores $200",
      count: "1",
    },
    { icon: <WalletIcon />, label: "Bolso protegido $200", count: "1" },
  ],
};

const PLAN_BASICO = {
  id: "basico",
  name: "Plan Esencial",
  price: 204,
  services: [
    { icon: <LocalShippingIcon />, label: "Grúa por accidente", count: "3" },
    { icon: <BuildIcon />, label: "Cambio de llanta", count: "3" },
    { icon: <LockIcon />, label: "Apertura de puertas", count: "3" },
    {
      icon: <HealthAndSafetyIcon />,
      label: "Ambulancia por accidente",
      count: "Ilimitado",
    },
    {
      icon: <GavelIcon />,
      label: "Asistencia legal telefónica",
      count: "Ilimitado",
    },
    {
      icon: <StethoscopeIcon />,
      label: "Telemedicina general",
      count: "Ilimitado",
    },
    { icon: <HomeIcon />, label: "Médico a domicilio", count: "Ilimitado" },
    {
      icon: <PetsIcon />,
      label: "Orientación veterinaria telefónica",
      count: "Ilimitado",
    },
    { icon: <HotelIcon />, label: "Hotel para mascotas", count: "2" },
    {
      icon: <HandymanIcon />,
      label: "Cerrajería, electricidad y plomería",
      count: "3",
    },
    {
      icon: <ChairIcon />,
      label: "Limpieza de muebles (8 puestos)",
      count: "1",
    },
    {
      icon: <DirectionsCarIcon />,
      label: "Vehículo sustituto (5 días)",
      count: "1",
    },
    { icon: <PaidIcon />, label: "Raspones y abolladuras $100", count: "1" },
    {
      icon: <CarRepairIcon />,
      label: "Reparación parabrisas/retrovisores $100",
      count: "1",
    },
    { icon: <WalletIcon />, label: "Bolso protegido $100", count: "1" },
    {
      icon: <FlightIcon />,
      label: "Traslado aeropuerto Quito/Gye/Cuenca",
      count: "1",
    },
  ],
};

const PLANS = [PLAN_PLUS, PLAN_BASICO];

const DOCUMENT_TYPES = [
  { value: "CI", label: "Cédula de identidad" },
  { value: "RUC", label: "RUC" },
  { value: "PPN", label: "Pasaporte" },
];

const INITIAL_BUYER = {
  tipoDocumento: "",
  documento: "",
  nombre: "",
  apellido: "",
  correo: "",
  telefono: "",
  direccion: "",
  placa: "",
};

export default function ProductsPage() {
  const classes = useStyles();

  const { urlServices } = useContext(UrlServicesContext);

  const [selectedId, setSelectedId] = useState(null);
  const [selectedAdvisor, setSelectedAdvisor] = useState(null);
  const [buyer, setBuyer] = useState(INITIAL_BUYER);
  const [advisors, setAdvisors] = useState([]);
  const [loadingAdvisors, setLoadingAdvisors] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [openPayDialog, setOpenPayDialog] = useState(false);
  const [openFrequentQuestion, setOpenFrequentQuestion] = useState(false);

  useEffect(() => {
    const fetchAdvisors = async () => {
      setLoadingAdvisors(true);
      try {
        const response = await axios.get(`${urlServices}advisor/list`);
        // Solo los activos
        setAdvisors(response.data.filter((a) => a.status === 1));
      } catch (error) {
        console.error("Error cargando asesores:", error);
      } finally {
        setLoadingAdvisors(false);
      }
    };

    fetchAdvisors();
  }, [urlServices]);

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleBuyer = (field, filteredValue) => (e) => {
    const value =
      filteredValue !== undefined ? filteredValue : (e?.target?.value ?? "");
    setBuyer((prev) => ({ ...prev, [field]: value }));
    if (field === "correo") {
      setEmailError(value.length > 0 && !validateEmail(value));
    }
  };

  const buyerComplete =
    buyer.tipoDocumento &&
    buyer.documento &&
    buyer.nombre &&
    buyer.apellido &&
    buyer.correo &&
    buyer.telefono &&
    buyer.direccion &&
    buyer.placa &&
    !emailError;

  const canPay = Boolean(selectedId && selectedAdvisor?.id && buyerComplete);

  const handlePay = () => {
    if (!canPay) return;
    setOpenPayDialog(true);
  };

  const handleCloseFrequentQuestion = () => {
    setOpenFrequentQuestion(false);
  };

  return (
    <Fragment>
      <Header />
      <div className={classes.page}>
        {/* ── Tarjetas de planes ── */}
        <div className={classes.cardsWrap}>
          <Grid container spacing={3} sx={{ mt: { xs: 20, md: 10 } }}>
            {PLANS.map((plan) => {
              const isSelected = selectedId === plan.id;
              return (
                <Grid item xs={12} md={6} key={plan.id}>
                  <div
                    className={`${classes.card} ${isSelected ? classes.cardSelected : ""}`}
                    onClick={() => setSelectedId(plan.id)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ")
                        setSelectedId(plan.id);
                    }}
                  >
                    <div className={classes.cardHeader}>
                      <p className={classes.cardHeaderTitle}>{plan.name}</p>
                      <span className={classes.cardPrice}>${plan.price}</span>
                    </div>

                    <div>
                      {plan.services.map((s, idx) => (
                        <div className={classes.serviceRow} key={idx}>
                          <span className={classes.serviceIcon}>{s.icon}</span>
                          <span>{s.label}</span>
                          <span className={classes.serviceCount}>
                            {s.count}
                          </span>
                        </div>
                      ))}
                    </div>

                    <div className={classes.cardFooter}>
                      <Typography sx={{ fontSize: "0.8rem", color: "#6B7585" }}>
                        Valor total anual
                      </Typography>
                      <div
                        className={classes.selectLabel}
                        style={{ color: isSelected ? ORANGE : "#9AA4B2" }}
                      >
                        {isSelected ? (
                          <CheckCircleIcon fontSize="small" />
                        ) : (
                          <RadioButtonUncheckedIcon fontSize="small" />
                        )}
                        {isSelected ? "Seleccionado" : "Seleccionar"}
                      </div>
                    </div>
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </div>

        {/* ── Asesor ── */}
        <div className={classes.advisorWrap}>
          <div className={classes.advisorBox}>
            {!selectedId && (
              <Alert severity="info" sx={{ mb: 2, fontSize: 12 }}>
                Selecciona un plan para habilitar el formulario.
              </Alert>
            )}
            <Typography className={classes.sectionTitle} sx={{ mb: 1 }}>
              Seleccionar Asesor
            </Typography>
            <Autocomplete
              options={advisors}
              getOptionLabel={(option) => option.name || ""}
              value={selectedAdvisor}
              onChange={(event, newValue) => setSelectedAdvisor(newValue)}
              loading={loadingAdvisors}
              disabled={!selectedId}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Busca y selecciona el asesor"
                  variant="outlined"
                  size="small"
                />
              )}
            />
          </div>
        </div>

        {/* ── Datos del comprador ── */}
        <div className={classes.advisorWrap} style={{ marginTop: 24 }}>
          <div className={classes.advisorBox}>
            <Typography className={classes.sectionTitle} sx={{ mb: 1 }}>
              Datos del comprador
            </Typography>
            <Grid container spacing={2}>
              {/* Tipo de documento */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Tipo de documento"
                  value={buyer.tipoDocumento}
                  onChange={handleBuyer("tipoDocumento")}
                  variant="outlined"
                  size="small"
                  fullWidth
                >
                  {DOCUMENT_TYPES.map((dt) => (
                    <MenuItem key={dt.value} value={dt.value}>
                      {dt.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Número de documento */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Número de documento"
                  value={buyer.documento}
                  variant="outlined"
                  size="small"
                  fullWidth
                  autoComplete="off"
                  disabled={!buyer.tipoDocumento}
                  placeholder={
                    buyer.tipoDocumento === "CI"
                      ? "Ej: 1712345678"
                      : buyer.tipoDocumento === "RUC"
                        ? "Ej: 1712345678001"
                        : buyer.tipoDocumento === "PPN"
                          ? "Ej: A1234567"
                          : "Número de documento"
                  }
                  onChange={(e) => {
                    let value = e.target.value;
                    if (buyer.tipoDocumento === "CI") {
                      value = value.replace(/[^0-9]/g, "").slice(0, 10);
                    } else if (buyer.tipoDocumento === "RUC") {
                      value = value.replace(/[^0-9]/g, "").slice(0, 13);
                    } else if (buyer.tipoDocumento === "PPN") {
                      value = value.slice(0, 13);
                    } else {
                      value = value.slice(0, 13);
                    }
                    handleBuyer("documento", value)();
                  }}
                  inputProps={{ maxLength: 13 }}
                />
              </Grid>

              {/* Nombre */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Nombre del comprador"
                  value={buyer.nombre}
                  onChange={(e) => {
                    const filteredValue = e.target.value.replace(
                      /[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g,
                      "",
                    );
                    handleBuyer("nombre")({ target: { value: filteredValue } });
                  }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  placeholder="Ej: Juan"
                  inputProps={{ maxLength: 50 }}
                  autoComplete="off"
                  helperText={"Ingresa un nombre válido (mínimo 3 caracteres)."}
                />
              </Grid>

              {/* Apellido */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Apellido del comprador"
                  value={buyer.apellido}
                  onChange={(e) => {
                    const filteredValue = e.target.value.replace(
                      /[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g,
                      "",
                    );
                    handleBuyer("apellido")({
                      target: { value: filteredValue },
                    });
                  }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  placeholder="Ej: Pérez"
                  inputProps={{ maxLength: 50 }}
                  autoComplete="off"
                  helperText={
                    "Ingresa un apellido válido (mínimo 3 caracteres)."
                  }
                />
              </Grid>

              {/* Correo */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Correo electrónico"
                  type="email"
                  value={buyer.correo}
                  onChange={handleBuyer("correo")}
                  variant="outlined"
                  size="small"
                  fullWidth
                  placeholder="correo@ejemplo.com"
                  error={emailError}
                  helperText={
                    emailError ? "Ingresa un correo electrónico válido." : ""
                  }
                  inputProps={{ maxLength: 150 }}
                  autoComplete="off"
                />
              </Grid>

              {/* Teléfono  */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Teléfono de contacto"
                  value={buyer.telefono}
                  onChange={(e) => {
                    const soloNumeros = e.target.value.replace(/[^0-9]/g, "");
                    handleBuyer("telefono")({
                      ...e,
                      target: { ...e.target, value: soloNumeros },
                    });
                  }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  placeholder="Ej: 0991234567"
                  inputProps={{
                    maxLength: 25,
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                  autoComplete="off"
                />
              </Grid>

              {/* Placa */}
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Placa del vehículo"
                  value={buyer.placa}
                  onChange={handleBuyer("placa")}
                  variant="outlined"
                  size="small"
                  fullWidth
                  placeholder="Ej: ABC-1234"
                  inputProps={{
                    maxLength: 50,
                    style: { textTransform: "uppercase" },
                  }}
                  autoComplete="off"
                />
              </Grid>

              {/* Dirección */}
              <Grid item xs={12} sm={8}>
                <TextField
                  label="Dirección"
                  value={buyer.direccion}
                  onChange={handleBuyer("direccion")}
                  variant="outlined"
                  size="small"
                  fullWidth
                  placeholder="Calle principal, número, ciudad"
                  inputProps={{ maxLength: 255 }}
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </div>
        </div>

        {/* ── Botones ── */}
        <div className={classes.ctaWrap}>
          <Divider sx={{ mb: 4 }} />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 12,
              flexWrap: "wrap",
            }}
          >
            <button
              className={`${classes.payButton} ${canPay ? classes.payButtonActive : classes.payButtonDisabled}`}
              onClick={handlePay}
              disabled={!canPay}
            >
              Continuar
            </button>
          </div>
          <Typography className={classes.helperText} sx={{ mt: 1 }}>
            {canPay
              ? "Continúa para registrar al cliente y elegir si paga ahora o se le envía un enlace."
              : "Completa todos los campos para continuar."}
          </Typography>
        </div>
        <Grid container>
          <Grid item xs={12} sm={12} sx={{ mt: 3 }}>
            <center>
              <span
                onClick={() => setOpenFrequentQuestion(true)}
                style={{
                  fontSize: 12,
                  textTransform: "none",
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                  fontWeight: 500,
                  lineHeight: 1.75,
                  color: "#000",
                  cursor: "pointer",
                  border: "1px solid dimgrey",
                  padding: "4px 10px",
                  borderRadius: 4,
                  fontWeight: "bold",
                }}
              >
                Terminos y condiciones - Políticas de protección de datos -
                Preguntas frecuentes
              </span>
            </center>
          </Grid>
        </Grid>
      </div>

      {/* Footer */}
      <Grid container>
        <Grid item xs={12} md={12} sx={{ mt: 2 }}>
          <img
            src={footer}
            alt="footer"
            style={{ width: "100%", objectFit: "cover" }}
          />
        </Grid>
      </Grid>
      {openPayDialog && (
        <AyasaPaymentDialog
          open={openPayDialog}
          onClose={() => setOpenPayDialog(false)}
          buyer={buyer}
          plan={PLANS.find((p) => p.id === selectedId)}
          advisor={selectedAdvisor}
        />
      )}
      {openFrequentQuestion && (
        <FrequentQuestionsAyasa
          open={openFrequentQuestion}
          exit={handleCloseFrequentQuestion}
        />
      )}
    </Fragment>
  );
}
